// extracted by mini-css-extract-plugin
export default {"bottom":"hQECd7TCzpXUy6Dmm6Yj_","buildingButton":"_2CXEOGWf45HdooH6JXUyu3"};